(function () {
    'use strict';

    angular.module('app.truck', [
        'app.core'
    ]);
})();
